//
//
//
//
//
//
//
//
//
export default {
  name: "AuditManage",
  data: function data() {
    return {
      isRouterAlive: true
    };
  },
  created: function created() {
    console.log('created AuditManage');
  },
  activated: function activated() {
    var _this = this;

    console.log('activated AuditManage');
    this.isRouterAlive = false;
    this.$nextTick(function () {
      return _this.isRouterAlive = true;
    });
  }
};